<template>
    <div class>
        <div class="row">
            <div class="col-md-6">
                <CCard class="box-shadow-card border-none p-0" v-if="refundOrderObj">
                    <header class="card-header pt-4 pb-4">
                        <div class="row">

                            <div class="status-wrap col">
                                <div v-if="orderDetails">
                                    <div :class="orderDetails.status == REFUND_ORDER_DET.ONLY_PROCESS ? 'partial-paid'
                                    : orderDetails.status == REFUND_ORDER_DET.SUCCESS_FAIL?'processing_c':
                                        orderDetails.status == REFUND_ORDER_DET.SUCCESS?'paid':'unpaid'" class="d-flex align-item-center">
                                        <div class="dot">

                                        </div>
                                        <strong v-if="orderDetails">
                                            {{orderDetails.status == REFUND_ORDER_DET.SUCCESS ? $t('refundDet.refundSuccess'):
                                            orderDetails.status == REFUND_ORDER_DET.SUCCESS_FAIL ?
                                            $t('refundDet.refundProcessing') : orderDetails.status == REFUND_ORDER_DET.ONLY_PROCESS && ADMIN_SIGNIN_RES ?
                                            $t('refundDet.newRefundReq') :orderDetails.status == REFUND_ORDER_DET.ONLY_PROCESS && AGENT_SIGNIN_RES ?
                                             $t('refundDet.refundReq') : $t('refundDet.refundFailed')}}
                                            <!-- Ticketed Success -->
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right col" v-if="refundOrderObj.orderId">
                                <span class="white-space-pre gray-f">{{$t('refundDet.resID')}}</span> <strong>{{refundOrderObj.orderId}}</strong>
                            </div>

                        </div>
                    </header>
                    <CCardBody>


                        <div class="d-flex justify-content-between row pt-3">
                            <CCol>
                                <div v-if="refundOrderObj.agencyname" class="d-flex">

                                    <div>
                                        <img src="@imgPath/img/svg/icons/user-gray.svg" alt="" height="15px"
                                             width="15px" class="mr-10px">
                                    </div>
                                    <div>
                                        <span class="white-space-pre gray-f">{{$t('refundDet.agencyName')}}</span> <br/>
                                        <span class="white-space-pre ">{{refundOrderObj.agencyname}}</span>
                                    </div>

                                </div>
                            </CCol>

                            <CCol>
                                <div v-if="refundOrderObj.agencyCode" class="d-flex">
                                    <div class="">
                                        <img src="@imgPath/img/svg/icons/calender-gray.svg" alt="" height="15px"
                                             width="15px" class="mr-10px">
                                    </div>
                                    <div>
                        <span class="white-space-pre gray-f">


              {{$t('refundDet.agencyCode')}}
                </span>
                                        <br/>
                                        <span class='white-space-pre ml-auto'>
             {{refundOrderObj.agencyCode}}
                </span>
                                    </div>


                                </div>
                            </CCol>


                        </div>
                        <br/>
                        <div class="d-flex justify-content-between row">


                            <CCol md="6">
                                <div v-if="refundOrderObj.username" class="d-flex">
                                    <div>
                                        <img src="@imgPath/img/svg/icons/user-gray.svg" alt="" height="15px"
                                             width="15px" class="mr-10px">
                                    </div>

                                    <div>
                                        <span class="white-space-pre gray-f">{{$t('ticketingQueue.bookedBy')}}</span><br/>
                                        <span class="white-space-pre">{{refundOrderObj.username}}</span>
                                    </div>

                                </div>
                            </CCol>
                            <CCol md='6'>
                                <div v-if="refundOrderObj.username" class="d-flex">
                                    <div>
                                        <img src="@imgPath/img/svg/icons/user-gray.svg" alt="" height="15px"
                                             width="15px" class="mr-10px">
                                    </div>
                                    <div>
                                        <span class='white-space-pre gray-f '>{{$t('refundDet.reqBy')}}</span> <br/>
                                        <span class="white-space-pre ml-auto">{{refundOrderObj.username}}</span>
                                    </div>

                                </div>
                            </CCol>
<!--                            <CCol>-->
<!--                                <div v-if="refundOrderObj.orderId" class="d-flex">-->
<!--                                    <div>-->
<!--                                        <img src="@imgPath/img/svg/icons/ticket-gray.svg" alt="" height="15px"-->
<!--                                             width="15px" class="mr-10px">-->
<!--                                    </div>-->
<!--                                    <div>-->
<!--                                        <span class="white-space-pre gray-f">{{$t('refundDet.resID')}}</span> <br/>-->
<!--                                        <span class="white-space-pre ml-auto">{{refundOrderObj.orderId}}</span>-->
<!--                                    </div>-->

<!--                                </div>-->
<!--                            </CCol>-->


                        </div>
                        <br/>


                        <!-- <div class="d-flex">

                            <div>
                                <img src="@imgPath/img/svg/icons/ticket-gray.svg" alt="" height="15px" width="15px"
                                     class="mr-10px">
                            </div>
                            <div>
                                <span class="white-space-pre gray-f">{{$t('refundDet.pnr')}}</span> <br/>

                                <span class="white-space-pre" v-if="refundOrderObj.FlightDetails">
                <span v-for="(flight, index) in refundOrderObj.FlightDetails" :key="'f' + index">
                  <span v-if="flight.pnr">{{ flight.pnr +' ,'}}</span>
                  <span v-else>{{ " - " }}</span>
                </span>
              </span>
                            </div>

                        </div> -->

                        <br/>
                    </CCardBody>
                </CCard>
                <CCard class="box-shadow-card border-none p-0">
                    <CCardBody v-if="orderDetails && orderDetails.paymentDetails" class="pb-0">
                        <div class="pb-3">
                            <strong>{{$t('refundDet.pricingSummary')}}</strong>
                        </div>
                        <hr>
                        <table class="payment-details">
                            <tbody>
                            <tr>
                                <td class="w-100">
                                    <span class="white-space-pre">{{$t('refundDet.orderDet')}}</span>
                                </td>
                                <td v-if="refundOrderObj && refundOrderObj.currency" class="max-w-65px">
                                    <div class="ml-auto white-space-pre">{{ refundOrderObj.currency+' '}}</div>
                                </td>
                                <td class="text-right d-flex justify-content-end">
                                <span class="white-space-pre">{{ orderDetails.paymentDetails.orderTotal|currencyFormat(refundOrderObj.currency)}}</span>
                                </td>
                            </tr>
                            <tr  v-if="refundOrderObj.currency">
                                <td class="w-100">
                                    <span class="white-space-pre">{{$t('refundDet.paymentFees')}}</span>
                                </td>
                                <td class="max-w-65px">
                                    <span class="ml-auto white-space-pre">{{ refundOrderObj.currency+' '}}</span>
                                </td>
                                <td class="text-right d-flex justify-content-end">
                                    <span>{{ orderDetails.paymentDetails.paymentFee|currencyFormat(refundOrderObj.currency)}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <hr>
                                </td>
                                <td>
                                    <hr>
                                </td>
                                <td>
                                    <hr>
                                </td>
                            </tr>
                            <tr>
                                <td class="w-100">
                                    <span>{{$t('refundDet.total')}}</span>
                                </td>
                                <td v-if="refundOrderObj && refundOrderObj.currency" class="max-w-65px">
                                    <div class="white-space-pre ">{{ refundOrderObj.currency+' '}}</div>
                                </td>
                                <td class="text-right d-flex justify-content-end">
                                    <div class="white-space-pre ml-10px"
                                    >{{ orderDetails.paymentDetails.paymentTotal|currencyFormat(refundOrderObj.currency)}}
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                             <div v-if="orderDetails"   @click="navigateToPaymentHis"
                            class="c-pointer blue-text m-auto ml">
                        <span class="pr-3 ">
                            {{$t('bookingDetail.paymentHistory')}}
                        </span>
                             </div>

                    </CCardBody>
                </CCard>
            </div>
            <div class="col-md-6">
                <cEditFlight
                        v-if="lsFlights && lsFlights.length"
                        :viewOnly="true"
                        :lsFlights="lsFlights"
                        :journeyType="orderDetails.journeyType"
                        :showPax="true"
                ></cEditFlight>
            </div>
        </div>
        <div class="card box-shadow-card border-none p-0 " v-if="!isLoading">
            <footer>
        <div v-if="ADMIN_SIGNIN_RES && orderDetails?(orderDetails.status == 10||orderDetails.status == 15):AGENT_SIGNIN_RES"
              class="d-flex justify-content-end">
            <CButton
                    @click="goBack()"
                    class="btn align-right btn-lit-blue btn-success m-10px bg-danger width-125px"
            >{{ $t("refundDet.goBack") }}
            </CButton>


        </div>
            </footer>
        </div>


        <!-- <cEditPassn :viewOnly='false' :lsPassn='lsPassn'></cEditPassn> -->
        <!--    <br />-->
        <ValidationObserver
                v-if=" ADMIN_SIGNIN_RES  &&  orderDetails && (orderDetails.status==REFUND_ORDER_DET.ONLY_PROCESS ||orderDetails.status==REFUND_ORDER_DET.SUCCESS_FAIL )"
                v-slot="{ handleSubmit }"
        >
            <CForm @submit.prevent="handleSubmit(validateRefundOrder)" autocomplete="off">
                <CCardFooter>
                    <div class="pt-3 pb-3">
                        <strong>
                            Updated Refund Status
                        </strong>

                    </div>
                    <hr>

                    <CRow>
                        <CCol md="4">
                            <div class="pt-3">
                                <div class="mb-2">
                                    <strong>{{$t('refundDet.updateStatus')}}</strong>
                                </div>


                                <div v-if="orderDetails && orderDetails.status">
                                    <ValidationProvider tag="div" rules="required" vid="1" v-slot="{ errors }">
                                        <multiselect

                                                @input="onUpdateStatusChange"
                                                :allow-empty="false"
                                                :options="lsUpdateStatus"
                                                v-model="updateStatus"
                                                :multiple="false"
                                                track-by="code"
                                                label="name"
                                                deselectLabel
                                                deselectGroupLabel
                                                selectLabel
                                                selectedLabel
                                        >
                                        <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                        </multiselect>
                                        <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                            <span>{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>

                            </div>
                        </CCol>
                        <CCol md="4" v-if=" updateStatus && updateStatus.code==REFUND_UPDATE_STATUS.SUCCESS">
                            <div  class="pt-3">
                                <div class="mb-2">
                                    <Strong v-if="refundOrderObj.currency">{{refundOrderObj.currency }}</Strong>
                                </div>           
                                <cTextInputComponent
                                        class="inner-label-none"
                                        v-if=" orderDetails.paymentDetails&&   orderDetails.paymentDetails.paymentTotal && orderDetails.paymentDetails.refundablePrice && refundOrderObj.currency"
                                        :isAmountField="true"
                                        :rules="'required|noInitialSpace|onlynumber|validDecimal|no_zero|maximum_value:'+ 
                                        orderDetails.paymentDetails.refundablePrice+','+refundOrderObj.currency "
                                        v-model="refundDet.amount"
                                        @onFocus="onRemoveCurrFormat(refundDet.amount)"
                                        @onBlur="formatRefundAmt(refundDet.amount,refundOrderObj.currency)"
                                ></cTextInputComponent>
                            </div>
                        </CCol>


                        <CCol md="4">
                            <div class="pt-3">
                                <div class="mb-2">
                                    <strong>{{$t('refundDet.ref')}}</strong>
                                </div>


                                <cTextInputComponent v-model="refundDet.ref" :label="$t('refundDet.ref')"
                                                     class="inner-label-none"></cTextInputComponent>
                            </div>
                        </CCol>
                        <CCol md="4">

                        </CCol>
                    </CRow>
                    <div @click="toggleRefund" v-if="orderDetails&&!ADMIN_SIGNIN_RES" class="mt-3">
                        <div class="d-flex align-items-center">
                            <input type="checkbox" :checked="isRefund" class="mr-2"/>
                            <span>{{ $t("refundDet.agree") }}</span>
                            <a class="active-link pl-1 pr-1" @click="isFRModalShow=true">{{ ' '+ $t("refundDet.tc")+' '
                                }}</a>
                            <span>{{ $t("refundDet.proceed") }}</span>
                        </div>
                    </div>


                </CCardFooter>

                <CCardFooter v-if="!isLoading">
                    <div>
                        <CAlert v-if="alertValue" show color="danger">
                            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                                <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                            </div>
                            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                                <span>{{$t("cAlert.errorCode")+' : '}}</span>
                                <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                            </div>
                            <div v-if="alertValue&&alertValue.constructor==String">
                                <p>{{alertValue}}</p>
                            </div>
                        </CAlert>
                    </div>

                    <div class="farerule-wrapper">
                        <CModal
                                :show.sync="isFRModalShow"
                                :backdrop="true"
                                :closeOnBackdrop="true"
                                :centered="true"
                                size="lg"
                                color="dark"
                        >


                            <h4 class="f-bold" v-html="$t('tc.title',{title:$t('tc.refund')})"></h4>
                            <br/>
                            <span v-html="$t('tc.titleContent')"></span>
                            <br/>
                            <h4 v-html="$t('tc.tc')"></h4>
                            <br/>
                            <br/>
                            <span v-html="$t('tc.tcContent')"></span>
                            <br/>
                            <span v-html="$t('tc.pointsToNote')"></span>
                            <br/>
                            <br/>
                            <span v-html="$t('tc.pnContent')"></span>
                            <template #footer-wrapper>
                                <CCardBody class="d-flex justify-content-end">
                                    <CRow class="confirm-btn-wrapper">

                                        <CButton
                                                @click="isFRModalShow=false"
                                                :color="'success'"
                                                aria-pressed="true"
                                        >OK
                                        </CButton>

                                    </CRow>
                                </CCardBody>
                            </template>
                            <!-- <span style="text-align: center">{{$t('tc.text')}}</span> -->
                        </CModal>
                    </div>

                    <CRow class="d-flex justify-content-end">
                        <CButton
                                @click="goBack()"
                                class="btn align-right btn-lit-blue btn-success m-10px bg-danger width-125px"
                        >{{ $t("refundDet.goBack") }}
                        </CButton>
                        
                        <CButton v-if="orderDetails"
                                 type="submit"
                                 class="btn align-right btn-success m-10px bg-success width-125px white-space-pre"
                        >{{ $t("refundDet.updateStatus") }}
                        </CButton>
                    </CRow>
                </CCardFooter>
            </CForm>
        </ValidationObserver>

        <cAlertModal
                v-if="isConfirmModal"
                :show="isConfirmModal"
                :buttonList="[
        { name: $t('refundDet.no'), func: toggleConfirmModal },
        { name: $t('refundDet.yes'), func: onConfirmRefund },
      ]"
                :key="1 + 'a'"
                :desc="$t('refundDet.confirm',{name:updateStatus.name})"
                :status="2"
        ></cAlertModal>

        <cAlertModal
                v-if="isSuccessModal"
                :show="isSuccessModal"
                :key="1 + 'b'"
                :desc="$t('refundDet.succDesc')"
                :buttonList="[{ name: $t('refundDet.ok'), func: navToBookingDet }]"
                :status="1"
        ></cAlertModal>     
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import {
        COMPONENT_NAME,
        PATHNAME,
        REFUND_SEGMENT_STATUS,
        REFUND_UPDATE_STATUS,
        REFUND_ORDER_DET, TRIP
    } from "../../../../util/constants";
    import multiselect from "vue-multiselect";
    import {ValidationObserver, ValidationProvider} from "vee-validate";
    import {
        addClassToBody,
        removeClassBody,
        cloneDeep,
        OrderByList,
        removeCurrFormat, OrderBy,showPaymentHistory
    } from "../../../../util/util";

    import Logger from "../../../../services/logger";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../../config/API_DATA";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";

    import apiRefundRequested from "./../../../../services/apiRefundRequested";

    import apiRefundFullFill from "./../../../../services/apiRefundFullFill";

    import apiRefundHold from "./../../../../services/apiRefundHold";
    import apiRefundDecline from "./../../../../services/apiRefundDecline";

    import BaseConfiguration from "../../../../config/base";
    import {
        handleJWT,
        getErrorAlertValue,
        handleSessionExist
    } from "../../../../util/util";
    import {
        ROUTER_PARAM,
        PAYMENT_PROCEED_TO,
        PROCEED_TO_TYPE
    } from "../../../../util/constants";
    import router, {navigate, goBack} from "../../../../router/index";
    import cEditFlight from "./../../../../components/booking/flight/manage/cEditFlight";
    import cEditPassn from "./../../../../components/booking/flight/manage/cEditPassn";
    import cAlertModal from "./../../../../components/form/cAlertModal";

    import cTextInputComponent from "./../../../../components/form/cTextInputComponent";
import { getDiffBtwDates } from '../../../../util/date/dateFunctions';

    export default {
        name: COMPONENT_NAME.REFUND_DET,

        components: {
            cEditFlight,
            cEditPassn,
            cAlertModal,
            cTextInputComponent,
            ValidationObserver,
            ValidationProvider,
            multiselect
        },
        data: () => {
            return {
                REFUND_ORDER_DET: REFUND_ORDER_DET,
                REFUND_UPDATE_STATUS: REFUND_UPDATE_STATUS,
                isSuccessModal: false,
                isRefund: false,
                isConfirmModal: false,
                alertValue: null,
                isFRModalShow: false,
                refundDet: {
                    amount: 0,
                    ref: null,
                    succRef: "",
                },

                orderDetails: null,

                updateStatus: null,

                lsUpdateStatus: [],

                lsFlights: [],
                isLoading:true
            };
        },

        computed: {
           
            ...mapGetters("sRefundDetail", {refundOrderObj: "GET_REFUND_OBJ"}),
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sAgtLogin", {
                AGENT_SIGNIN_RES: "GET_SIGNIN_RES",
            }),
        },

        methods: {
         
            goBack() {
                goBack();
            },

            getCurrency(pCurrency, pTotal) {
                let retValue;
                retValue = retValue + ' ' + pTotal;
                return retValue;
            },
              navigateToPaymentHis() {
                try {
                  if(BaseConfiguration.isDebug) console.log("navigateToPaymentHis");

                    showPaymentHistory(this.orderDetails);
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.REFUND_DET,
                          "error in navigateToPaymentHis",
                          err.toString(),
                          "navigateToPaymentHis",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
          
                }, 

            onRemoveCurrFormat(pAmount) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");

                    this.refundDet.amount = removeCurrFormat(pAmount);

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in onRemoveCurrFormat",
                        err.toString(),
                        "onRemoveCurrFormat",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            formatRefundAmt(pAmount, pCurrency) {
                if (BaseConfiguration.isDebug) console.log(" formatRefundAmt");
                try {
                    this.refundDet.amount = this.$options.filters.currencyFormat(pAmount, pCurrency);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in formatRefundAmt",
                        err.toString(),
                        "formatRefundAmt",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getRefundReference(pFlights, PJourneyType) {
                let retValue = "";
                try {
                    if (BaseConfiguration.isDebug) console.log("getRefundReference");

                    pFlights = cloneDeep(pFlights);

                    if (pFlights && pFlights.length) {
                        pFlights.forEach(flight => {

                            retValue += flight.flight.DepAirport + "-" + flight.flight.ArrAirport + " "
                        })
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in getRefundReference",
                        err.toString(),
                        "getRefundReference",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            onUpdateStatusChange(pUpdateStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onUpdateStatusChange");

                    if (pUpdateStatus && pUpdateStatus.code == REFUND_UPDATE_STATUS.FAILED) {
                        this.refundDet.ref = this.$t('refundDet.refundFailedAlert')
                    } else if (pUpdateStatus && pUpdateStatus.code == REFUND_UPDATE_STATUS.SUCCESS) {
                        this.refundDet.ref = this.refundDet.succRef + this.getJourneyType();


                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in onUpdateStatusChange",
                        err.toString(),
                        "onUpdateStatusChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },


            getJourneyType() {
                let retValue = "";
                try {
                    if (BaseConfiguration.isDebug) console.log("getJourneyType");


                    if (this.orderDetails)
                        switch (this.orderDetails.journeyType) {

                            case TRIP.MULTI_CITY: {
                                retValue = this.$t('refundDet.multiCity')
                                break;
                            }

                            case TRIP.ROUND_TRIP: {
                                retValue = this.$t('refundDet.roundTrip')
                                break;
                            }

                            default: {
                                retValue = this.$t('refundDet.oneWay')
                            }
                        }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in getJourneyType",
                        err.toString(),
                        "getJourneyType",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            validateRefundOrder(pName) {
                try {
                    if (BaseConfiguration.isDebug) console.log(" validateRefundOrderT");

                    if (!this.isRefund&&this.AGENT_SIGNIN_RES) {
                        this.alertValue = this.$t('refundDet.alertTc');
                    } else {
                        this.alertValue = null
                        this.toggleConfirmModal();
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in  validateRefundOrder",
                        err.toString(),
                        " validateRefundOrder",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            async doRefundDecline(pOrderId, pRef) {
                try {
                    if (BaseConfiguration.isDebug) console.log("doRefundDecline");

                    if (pOrderId) {
                        let refundDeclineReq = apiRefundDecline.buildRequest(pOrderId),
                            pRef;

                        if (refundDeclineReq != null) {
                            let refundDeclineRes = await apiRefundDecline.getResponse(
                                refundDeclineReq
                            );

                            if (VALIDATE_SUCCESS_RES(refundDeclineRes)) {
                                //retValue = refundDeclineRes.data.data;
                                this.toggleSuccessModal();
                            } else {
                                let error = getErrorMessage(refundDeclineRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invallid Req";
                        }
                    } else {
                        throw " invalid  OrderId ";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in doRefundDecline",
                        err.toString(),
                        "doRefundDecline",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async doRefundFullFill(pOrderId, pRefundDet) {
                try {
                    if (BaseConfiguration.isDebug) console.log("doRefundFullFill");

                    if (pOrderId && pRefundDet) {
                        let refundFullFillReq = apiRefundFullFill.buildRequest(
                            pOrderId,
                            pRefundDet
                        );

                        if (refundFullFillReq != null) {
                            let refundFullFillRes = await apiRefundFullFill.getResponse(
                                refundFullFillReq
                            );

                            if (VALIDATE_SUCCESS_RES(refundFullFillRes)) {
                                // retValue = refundFullFillRes.data.data;
                                this.toggleSuccessModal();
                            } else {
                                let error = getErrorMessage(refundFullFillRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invallid Req";
                        }
                    } else {
                        throw " invalid  OrderId ";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in doRefundFullFill",
                        err.toString(),
                        "doRefundFullFill",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async doRefundHold(pOrderId, pRef) {
                try {
                    if (BaseConfiguration.isDebug) console.log("doRefundHold");

                    if (pOrderId) {
                        let refundHoldReq = apiRefundHold.buildRequest(pOrderId, pRef);

                        if (refundHoldReq != null) {
                            let refundHoldRes = await apiRefundHold.getResponse(refundHoldReq);

                            if (VALIDATE_SUCCESS_RES(refundHoldRes)) {
                                // retValue = refundHoldRes.data.data;
                                this.toggleSuccessModal();
                            } else {
                                let error = getErrorMessage(refundHoldRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invallid Req";
                        }
                    } else {
                        throw " invalid  OrderId ";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in doRefundHold",
                        err.toString(),
                        "doRefundHold",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            async getRequestedRefundList(pOrderId) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getRequestedRefundList");

                    if (pOrderId) {
                        let refundReq = apiRefundRequested.buildRequest(pOrderId);

                        if (refundReq != null) {
                            let refundRes = await apiRefundRequested.getResponse(refundReq);

                            if (VALIDATE_SUCCESS_RES(refundRes)) {
                                retValue = refundRes.data.data;
                            } else {
                                let error = getErrorMessage(refundRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invallid Req";
                        }
                    } else {
                        throw " invalid  OrderId ";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in getRequestedRefundList",
                        err.toString(),
                        "getRequestedRefundList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            navToBookingDet() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navToBookingDet");
                    
                    this.toggleSuccessModal();
                    navigate(PATHNAME.ALL_REFUND);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in navToBookingDet",
                        err.toString(),
                        "navToBookingDet",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            toggleRefund() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleRefund");
                    this.isRefund = !this.isRefund;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in toggleRefund",
                        err.toString(),
                        "toggleRefund",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            validateDepartureDate(pOrderDetails) {
                                    let retValue;

                try {
                  if(BaseConfiguration.isDebug) console.log("validateDepartureDate");
                    for(let i=0;i<pOrderDetails.flights.length;i++){
                          if(pOrderDetails.flights[i]&&pOrderDetails.flights[i].isSelected){
                              for(let j=0;j<pOrderDetails.flights[i].flightInfo.length;j++){
                                  if(pOrderDetails.flights[i].flightInfo[j]&&getDiffBtwDates(new Date(pOrderDetails.flights[i].flightInfo[j].flight.DepDate),
                                    new Date(),
                                    "days"
                                ) >= 0){
                                     retValue= true;
                                }else{
                                     retValue= false;
                                    break;
                                }
                              }
                      
                          }
                    }
                 
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.REFUND_DET,
                          "error in validateDepartureDate",
                          err.toString(),
                          "validateDepartureDate",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 return retValue;

                 
                }, 
            onConfirmRefund() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onConfirmRefund");
                    this.toggleConfirmModal();

                    if (this.orderDetails && this.updateStatus && this.refundOrderObj) {
                        switch (this.orderDetails.status) {
                            case REFUND_ORDER_DET.ONLY_PROCESS: {
                                this.doRefundHold(
                                    this.refundOrderObj.orderId,
                                    this.refundDet.ref
                                );
                                break;
                            }

                            case REFUND_ORDER_DET.SUCCESS_FAIL: {
                                if (this.updateStatus.code == REFUND_UPDATE_STATUS.SUCCESS) {
                                   if(this.validateDepartureDate(this.orderDetails)){
                                   (this.refundDet.currency = this.refundOrderObj.currency),
                                        this.doRefundFullFill(
                                            this.refundOrderObj.orderId,
                                            this.refundDet
                                        );
                                   }else{
                                  this.alertValue=this.$t('refundDet.alertPastDate')            
                                   }
                                   

                                } else if (
                                    this.updateStatus.code == REFUND_UPDATE_STATUS.FAILED
                                ) {
                                    this.doRefundDecline(
                                        this.refundOrderObj.orderId,
                                        this.refundDet.ref
                                    );
                                }

                                break;
                            }
                        }
                    } else {
                        throw " invalid refund order";
                    }

                    // this.toggleSuccessModal();
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in onConfirmRefund",
                        err.toString(),
                        "onConfirmRefund",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            toggleSuccessModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleSuccessModal");
                    this.isSuccessModal = !this.isSuccessModal;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in toggleSuccessModal",
                        err.toString(),
                        "toggleSuccessModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            toggleConfirmModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleConfirmModal");

                    this.isConfirmModal = !this.isConfirmModal;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in toggleConfirmModal",
                        err.toString(),
                        "toggleConfirmModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getFlightsList(pOrderDet,prefundOrderObj) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getFlightsList");
                    if (pOrderDet && pOrderDet.flights && pOrderDet.flights.length) {
                        // if(prefundOrderObj){
                        //     for (let i = 0; i < pOrderDet.flights.length; i++) {
                        //         pOrderDet.flights[i]["pnr"] = prefundOrderObj.pnr[i];
                                
                        //     }
                        // }
                        pOrderDet.flights.forEach(flight => {
                            flight.passengerInfo = this.getPassengersList(pOrderDet, flight);

                            if (
                                flight.segmentStatus == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED
                            ) {
                                flight.isSelected = true;
                            }

                            if (flight.flightInfo && flight.flightInfo.length) {
                                flight.flightInfo = OrderByList(
                                    flight.flightInfo,
                                    "connectingNumber",
                                    "asc"
                                );

                                this.refundDet.succRef = this.refundDet.succRef + this.getRefundReference(flight.flightInfo, this.orderDetails.journeyType);

                                flight.showFlightDet = false;
                                flight.orderType = pOrderDet.orderType;
                                flight.status = pOrderDet.status;
                                flight.travelDuration = this.getTravelDuration(flight.flightInfo)
                                flight.flightInfo.forEach(fInfo => {
                                    if (fInfo.flight) {
                                        if (pOrderDet.airline) {
                                            let airlineObj = Object.values(pOrderDet.airline).find(
                                                airline => airline.airline_code == fInfo.flight.opAirline
                                            );

                                            if (airlineObj) {
                                                fInfo.flight.airline_name = airlineObj.airline_name;
                                                fInfo.flight.logo_url = airlineObj.logourl;
                                            }
                                        }
                                        if (pOrderDet.airport) {
                                            fInfo.flight.arrCity =
                                                pOrderDet.airport[fInfo.flight.ArrAirport].city;
                                            fInfo.flight.depCity =
                                                pOrderDet.airport[fInfo.flight.DepAirport].city;
                                        }

                                    }
                                });
                            }
                        });
                        retValue = cloneDeep(pOrderDet.flights);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in getFlightsList",
                        err.toString(),
                        "getFlightsList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getPassengersList(pOrderDet, PFlightObj) {
                let retValue = [];

                try {
                    if (BaseConfiguration.isDebug) console.log("getPassengersList");

                    if (pOrderDet && pOrderDet.passengerInfo) {
                        let lsPassn = Object.values(pOrderDet.passengerInfo);
                        let paxList = [];
                        if (lsPassn && lsPassn.length && PFlightObj) {
                            lsPassn.forEach(pax => {
                                let ticketNumber = "";

                                if (PFlightObj.passengerInfo && PFlightObj.passengerInfo.length) {
                                    let paxInfo = PFlightObj.passengerInfo.find(info => {
                                        return info.paxId == pax.paxId;
                                    });

                                    if (paxInfo)
                                        paxInfo.isSelected =
                                            paxInfo.segmentStatus ==
                                            REFUND_SEGMENT_STATUS.CHANGE_REQUESTED;
                                    Object.keys(pax).forEach(key => {
                                        paxInfo[key] = pax[key];
                                    });
                                     paxList.push(paxInfo);
                                }
                            });
                             PFlightObj.passengerInfo = paxList; 
                        }
                        retValue = cloneDeep(PFlightObj.passengerInfo)

                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in getPassengersList",
                        err.toString(),
                        "getPassengersList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getUpdateStatusList(pName) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getUpdateStatusList");

                    retValue = [
                        {
                            name: this.$t("refundDet.refundProcessing"),
                            code: REFUND_UPDATE_STATUS.PROCESSING
                        },
                        {
                            name: this.$t("refundDet.refundSuccess"),
                            code: REFUND_UPDATE_STATUS.SUCCESS
                        },
                        {
                            name: this.$t("refundDet.refundFailed"),
                            code: REFUND_UPDATE_STATUS.FAILED
                        }
                    ];
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in getUpdateStatusList",
                        err.toString(),
                        "getUpdateStatusList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getTravelDuration(pFlights) {
                let retValue = 0;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTravelDuration");

                    if (pFlights && pFlights.length)
                        pFlights.forEach(flights => {
                            retValue += flights.flight.DurationInMin;
                        });
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.REFUND_DET,
                        "error in getTravelDuration",
                        err.toString(),
                        "getTravelDuration",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
        },

        async created() {
            try {
                if (BaseConfiguration.isDebug) console.log("created'");


                if (this.refundOrderObj && this.refundOrderObj.orderId) {

                    this.orderDetails = await this.getRequestedRefundList(
                        this.refundOrderObj.orderId
                    );
                    // if(this.orderDetails.paymentDetails.refundablePrice && this.refundOrderObj && this.refundOrderObj.currency){
                    //     this.orderDetails.paymentDetails.refundablePrice = 
                    //     this.$options.filters.formatNumber(
                    //     this.orderDetails.paymentDetails.refundablePrice.toString(),this.refundOrderObj.currency)
                    // }
                    this.lsUpdateStatus = this.getUpdateStatusList();
                    if (
                        this.orderDetails &&
                        this.orderDetails.status == REFUND_ORDER_DET.ONLY_PROCESS
                    ) {
                        this.lsUpdateStatus = this.lsUpdateStatus.filter(
                            status => status.code == REFUND_UPDATE_STATUS.PROCESSING
                        );
                        this.updateStatus = this.lsUpdateStatus[0];
                    } else if (
                        this.orderDetails &&
                        this.orderDetails.status == REFUND_ORDER_DET.SUCCESS_FAIL
                    ) {
                        this.lsUpdateStatus = this.lsUpdateStatus.filter(
                            status => status.code != REFUND_UPDATE_STATUS.PROCESSING
                        );
                        this.updateStatus = this.lsUpdateStatus[0];
                    }
                    // console.error(this.updateStatus);


                    this.lsFlights = this.getFlightsList(this.orderDetails,this.refundOrderObj);
                    this.refundDet.ref = this.refundDet.succRef + this.getJourneyType()
                }
                this.isLoading=false;
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.REFUND_DET,
                    "error in created'",
                    err.toString(),
                    "created'",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.REFUND_DET);
        },

        beforeDestroy() {
            removeClassBody();
        }
    };
</script>


<style lang="scss" scoped>
.processing_c{
    color: #20a8d8;
}
    .space {
        padding-left: 200px;
    }

    .active-link {
        color: #2f85eb !important;
        font-weight: bold;
        cursor: pointer;

        &:hover {
            text-decoration: underline !important;
        }

    }
</style>